import React from 'react';
import { FormattedMessage } from 'react-intl';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuestionCircle } from '@fortawesome/sharp-solid-svg-icons/faQuestionCircle';
import { Tooltip } from 'ui-components/components/tooltip';

import { ReadonlyFulfillmentPlanDate } from '../fulfillment-plan-dates/readonly-fulfillment-plan-date';
import { EditableFulfillmentPlanDate } from '../fulfillment-plan-dates/editable-fulfillment-plan-date';
import { ShipmentDetailsField } from '../field';
import { useFulfillmentPlanIdContext } from '../../../../../../fulfillment-plans/context/fulfillment-plan-id-context-provider';
import { useEntitiesFulfillmentPlanProperty } from '../../../../../../hooks/entities/selectors/fulfillment-plans';
import { useIsFulfillmentPlanEditable } from '../use-shipment-details';
import { updateFulfillmentPlansDeliverBy } from '../../../../../../fulfillment-plans/fulfillment-plans.api';
import { useHasFulfillmentPlanRestriction } from '../../../restrictions-context';
import { UiRestrictions } from '../../../../../../enums/component-states';
import messages from '../messages';
import style from './icon.module.less';

const DeliverByDateFieldId = 'deliver-by-date';

export const DeliverByDate = () => {
  const fulfillmentPlanId = useFulfillmentPlanIdContext();
  const { deliverByDate } = useEntitiesFulfillmentPlanProperty(fulfillmentPlanId, 'fulfillmentPlanDates');
  const isdeliverByEditable = useIsFulfillmentPlanEditable(fulfillmentPlanId);
  const isRestricted = useHasFulfillmentPlanRestriction(UiRestrictions.DeliverByDate);

  return (
    <ShipmentDetailsField
      label={<FormattedMessage {...messages.deliverByDate} />}
      labelFor={DeliverByDateFieldId}
      labelIcon={
        <Tooltip position='top' text={<FormattedMessage {...messages.deliverByDateTooltip} />}>
          <FontAwesomeIcon className={style.icon} icon={faQuestionCircle} />
        </Tooltip>
      }
    >
      {isdeliverByEditable ? (
        <EditableFulfillmentPlanDate
          apiCall={updateFulfillmentPlansDeliverBy}
          dateValueUtc={deliverByDate}
          disabled={isRestricted}
          fulfillmentPlanId={fulfillmentPlanId}
          id={DeliverByDateFieldId}
          shouldUseDateTimePicker
        />
      ) : (
        <ReadonlyFulfillmentPlanDate dateValueUtc={deliverByDate} shouldShowTime />
      )}
    </ShipmentDetailsField>
  );
};
